// extracted by mini-css-extract-plugin
var _1 = "NewSelectOption-module__animateUploadProgressBarWidth--DFqVd";
var _2 = "NewSelectOption-module__animatedBackground--S_uzl";
var _3 = "NewSelectOption-module__newIconContainer--jf6Z0";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "newIconContainer" }
